module.exports = "/virtual-football-league/img/amblems/left/Germany/Fake_Schalke.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Germany/Fake_Schalke.png
// module id = 2038
// module chunks = 4